import React, { useRef, useState } from 'react'
import makeStyles from '@mui/styles/makeStyles'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Typography from '@mui/material/Typography'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import styles from './securityStyles'
import { displaySnackbar } from '../../actions/main'
import { changeMyPassword } from '../../api/auth'
import { useAppDispatch } from '../../store'
import { requestPasswordReset } from '../../api/hds'
import TokTokDocTextField from '../Common/TextField'
import { isPasswordValid } from '../../utils/validators'
import { isEmailReal } from '../../utils/formUtils'
import useCurrentUser from '../../hooks/useCurrentUser'

// @ts-expect-error TS(2345) FIXME: Argument of type '(theme: any) => { button: { [x: ... Remove this comment to see the full error message
const useStyles = makeStyles(styles)

const Security: React.FC = () => {
    const dispatch = useAppDispatch()
    const classes = useStyles()

    // states
    const [loading, setLoading] = useState(false)
    const [needToBeReset, setNeedToBeReset] = useState(false)
    const password = useRef<HTMLInputElement>()
    const repeatedPassword = useRef<HTMLInputElement>()
    const user = useCurrentUser()
    const isTokTokDocMe = !user?.email ? true : !isEmailReal(user.email)

    /**
     * @description handle password on save button
     * @returns {void}
     */
    const handlePasswordSave = async () => {
        setLoading(true)
        const res = await requestPasswordReset(user.email)
        setLoading(false)
        if (res instanceof Error)
            dispatch(displaySnackbar('error', 'Une erreur est survenue, merci de re-essayer plus tard'))
        else
            dispatch(
                displaySnackbar(
                    'success',
                    'Nous avons envoyé un e-mail contenant les instructions pour changer votre mot de passe.',
                ),
            )
    }

    const changePasswordHandler = () => {
        setLoading(true)
        const passwordValue = password?.current?.value

        if (isPasswordValid(passwordValue) === true && passwordValue)
            changeMyPassword(passwordValue)
                .then(() => {
                    dispatch(
                        displaySnackbar('success', 'Mot de passe mis à jour.', undefined, `[Security] password update`),
                    )
                    setNeedToBeReset(true)
                    setLoading(false)
                })
                .catch((error: { message: string | string[] }) => {
                    dispatch(displaySnackbar('error', error.message))
                    setLoading(false)
                })
                .finally(() => {
                    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
                    password.current.value = ''
                    // @ts-expect-error TS(2531) FIXME: Object is possibly 'null'.
                    repeatedPassword.current.value = ''
                    setNeedToBeReset(false)
                })
    }

    /**
     * Checks password validity
     * @return {string} of error
     */
    const checkPasswordValidity = (hideError?: boolean) => {
        if (hideError && !repeatedPassword?.current?.value) return true
        const passwordValue = password?.current?.value
        const confirmValue = repeatedPassword?.current?.value
        return isPasswordValid(passwordValue, confirmValue)
    }

    return (
        <Paper className={classes.paper}>
            <Card>
                <CardContent>
                    <Grid container spacing={2} direction="column">
                        <Grid item xs={12}>
                            <Accordion elevation={2}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography variant="h3"> Modifier mon mot de passe </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {!isTokTokDocMe ? (
                                        <>
                                            {/* @ts-expect-error TS(2769) FIXME: No overload matches this call. */}
                                            <Button
                                                disabled={loading}
                                                variant="contained"
                                                color="primary"
                                                elevation={0}
                                                className={classes.button}
                                                onClick={handlePasswordSave}
                                            >
                                                Demander une modification du mot de passe
                                            </Button>
                                        </>
                                    ) : (
                                        <Grid container spacing={4} justifyContent="flex-start" wrap="nowrap">
                                            <Grid item xs={1}>
                                                <InfoOutlinedIcon color="secondary" />
                                            </Grid>
                                            <Grid item xs={10}>
                                                <Grid container spacing={2} alignItems="center">
                                                    <Grid item xs={12} md={12} lg={6}>
                                                        <Typography variant="h4">
                                                            Afin de répondre aux exigences réglementaires et de garantir
                                                            la sécurité des accès aux données, le mot de passe doit
                                                            comporter :
                                                        </Typography>
                                                        <Typography variant="h4">
                                                            - Le mot de passe doit être de 8 caractères minimum
                                                        </Typography>
                                                        <Typography variant="h4">
                                                            - Le mot de passe doit contenir au moins 1 majuscule
                                                        </Typography>
                                                        <Typography variant="h4">
                                                            - Le mot de passe doit contenir au moins 1 lettre minuscule
                                                        </Typography>
                                                        <Typography variant="h4">
                                                            - Le mot de passe doit contenir au moins un caractère
                                                            spécial
                                                        </Typography>
                                                        <Typography variant="h4">
                                                            - Le mot de passe doit contenir au moins 1 chiffre
                                                        </Typography>
                                                        <Typography variant="h4"> Exemple : Rteyazp1* </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} md={12} lg={1} />
                                                    <Grid item xs={12} md={12} lg={5}>
                                                        <Grid container spacing={2} direction="column">
                                                            <Grid item>
                                                                <TokTokDocTextField
                                                                    // @ts-expect-error TS(2339) FIXME: Property 'gridItemContent' does not exist on type ... Remove this comment to see the full error message
                                                                    className={classes.gridItemContent}
                                                                    inputRef={password}
                                                                    id="password1"
                                                                    label="Nouveau mot de passe"
                                                                    type="password"
                                                                    needToBeReset={needToBeReset}
                                                                    style={{
                                                                        marginTop: '-11px',
                                                                    }}
                                                                    defaultValue=""
                                                                    validator={() => checkPasswordValidity()}
                                                                />
                                                            </Grid>
                                                            <Grid item>
                                                                <TokTokDocTextField
                                                                    // @ts-expect-error TS(2339) FIXME: Property 'gridItemContent' does not exist on type ... Remove this comment to see the full error message
                                                                    className={classes.gridItemContent}
                                                                    inputRef={repeatedPassword}
                                                                    needToBeReset={needToBeReset}
                                                                    id="password2"
                                                                    type="password"
                                                                    label="Confirmation du mot de passe"
                                                                    defaultValue=""
                                                                    validator={() => checkPasswordValidity(true)}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <Grid container justifyContent="flex-end">
                                                                    {/* @ts-expect-error TS(2769) FIXME: No overload matches this call. */}
                                                                    <Button
                                                                        disabled={loading}
                                                                        variant="contained"
                                                                        color="primary"
                                                                        elevation={0}
                                                                        className={classes.button}
                                                                        onClick={changePasswordHandler}
                                                                    >
                                                                        MODIFIER
                                                                    </Button>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={1} />
                                        </Grid>
                                    )}
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Paper>
    )
}

export default Security
